import React, { useEffect, useState } from 'react';
import './payment.css';
import {Box, Button, Typography} from '@mui/material';
import {TbCurrencyRupee} from 'react-icons/tb';
import { useNavigate } from 'react-router';

export default function PaymentCard(props) {
    const [visa, setVisa] = useState(true);
    const [length, setLength] = useState(0);
    const [formValue, setFormValue] = useState({});
    const [err, setErr] = useState("");
    const [cardNumber, setCardNumber] = useState("");
    const navigate = useNavigate();
    const handleChange = (e)=>{
        setCardNumber(e.target.value);
        let len = e.target.value.length; 
        if(len==4){
            setLength((prev)=>prev+4);
        }
    }
    useEffect(()=>{
        if(cardNumber.length===19){
            setVisa(true);
        }
        else if(cardNumber.length===4){
            let temp = cardNumber;
            temp += " ";
            setCardNumber(temp);
        }
        else if(cardNumber.length===9){
            let temp = cardNumber;
            temp += " ";
            setCardNumber(temp);
        }
        else if(cardNumber.length===14){
            let temp = cardNumber;
            temp += " ";
            setCardNumber(temp);
        }
        else{
            setVisa(false);
        }
    }, [length, cardNumber]);
    const handleCancellation = ()=>{
        props.open(false);
    }
    const handleSubmit = (e)=> {
        e.preventDefault();
        const regex = /^[a-zA-Z ]{2,30}$/;
        const numReg = /^\d+$/;
        const cardReg = /^(?=.*\d)[\d ]+$/;
        const formData = new FormData(e.target);
        const tempObj = {};
        for(const [key, value] of formData){
            tempObj[key] = value;
        }
        if(!tempObj.cardInp || tempObj.cardInp.length<19 || !cardReg.test(tempObj.cardInp)){
            setErr("Please enter valid card number");
            setCardNumber("");
            setVisa(false);
            return;
        }
        else if(tempObj.month.length<2 || tempObj.month>12 || !numReg.test(tempObj.month)){
            setErr("Enter a valid month");
            return;
        }
        else if(tempObj.year.length<2 || tempObj.year<23 || !numReg.test(tempObj.year)){
            setErr("Enter a valid year");
            return;
        }
        else if(tempObj.cvv.length<3 || !numReg.test(tempObj.cvv)){
            setErr("Enter valid cvv");
        }
        else if(!tempObj.cardHolder){
            setErr("Enter card holder name");
        }
        else if(!regex.test(tempObj.cardHolder)){
            setErr("Enter a valid name");
        }
        else{
            setErr("");
            setFormValue(tempObj);
            setTimeout(()=>{
                navigate('/payments/success')
            }, 2000)
        }
    }
    const handleFocus = ()=>{
        setErr("");
    }
  return (
    <div>
        <div className='pay-card'>
            <Box
            display='flex'
            sx={{justifyContent: 'center', alignItems:'center', borderRadius:'5px', backgroundColor:'rgb(135, 206, 250)', width:'300px'}}
            >
                <p>Payable Amouunt: <TbCurrencyRupee /><Typography
                variant='body2'
                fontWeight='bold'
                component='span'
                >{props.amount}</Typography></p>
            </Box>
            <img src='/visa-mas.png' style={{width:'100px', height:'30px', float:'right'}} />
            <form onSubmit={handleSubmit}>
                <label htmlFor="number">Card Number</label>
                <input id='number' maxLength='19' style={{width: '60%', marginRight:'20px', fontSize:'130%'}} onChange={handleChange} value={cardNumber} name='cardInp' onFocus={handleFocus}/>
                <>{visa && <img src='https://clipground.com/images/visa-icon-clipart-2.jpg' style={{width:'30px', height:'30px', position:'fixed', top:'95px'}} />}</>
                <label htmlFor='validity'>Valid Upto</label>
                <input maxLength='2' placeholder='MM' style={{width: '50px', marginRight:'10px', textAlign:'center'}} name='month' onFocus={handleFocus}/>
                <span style={{marginRight:'10px', fontSize:'30px'}}>/</span>
                <input maxLength='2' placeholder='YY' style={{width: '50px', marginRight:'10px', textAlign:'center'}} name="year" onFocus={handleFocus}/>
                <label htmlFor='cvv'>CVV</label>
                <input maxLength='3' style={{width: '50px', marginRight:'20px'}} name='cvv' onFocus={handleFocus}/>
                <label htmlFor='name'>Name on Card</label>
                <input type='text' name='cardHolder' style={{width: '60%', marginRight:'20px', fontSize:'130%'}} onFocus={handleFocus}/>
                {err && <p style={{color:'red', fontSize:'14px'}}>{err}</p>}
                <Box
                display='flex'
                >
                <Button
                variant='contained'
                sx={{ marginRight:'50px', marginTop:'50px', display:'block'}}
                type='submit'
                >PAY</Button>
                <Button
                variant='contained'
                sx={{ marginTop:'50px', marginRight:'50px', display:'block'}}
                onClick={handleCancellation}
                >CANCEL</Button>
                </Box>
            </form>
           
        </div>
    </div>
  )
}
